import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BehaviorSubject, map, Observable} from "rxjs";

export const QP_COMPOSABLE_ROUTE = 'cr';

@Injectable({providedIn: 'root'})
export class ComposableRouteService {

  private _composedRoute = new BehaviorSubject<RouterCompose>({});

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe((params) => {
      const param = params[QP_COMPOSABLE_ROUTE];
      if (param) {
        try {
          const decode = decodeRoute(param);
          const parsed = JSON.parse(decode);
          this._composedRoute.next(parsed);
        } catch (e) {
          this._composedRoute.next({});
        }
      }
    });
  }

  /**
   * Update the url with current value
   * @param obj contains stored key-value
   **/
  private updateQueryParams(obj: RouterCompose) {
    const stringify = JSON.stringify(obj);
    const encoded = encodeRoute(stringify);
    if (Object.keys(obj).length === 0) {
      this.clean();
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {[QP_COMPOSABLE_ROUTE]: encoded},
        queryParamsHandling: 'merge'
      }).then();
    }
  }

  /**
   * Clean queryParams and state.
   * For example if keys are zero
   **/
  private clean() {
    // GEG facendo come veniva fatto sotto, annullavi tutte le sottoscrizioni al metodo vecchio
    // questo causava delle anomalie nel caso la chiamata a clean venisse fatta in una pagina
    // dopo aver fatto la sottoscrizione.
    // I componenti che utilizzano  composable route devono accertarsi di togliere la sottoscrizione

    // this._composedRoute = new BehaviorSubject<RouterCompose>({});
    this._composedRoute.next({}); // aggiorna il valore senza creare un nuovo subject

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: null,
      queryParamsHandling: '' //'replace'
    }).then()
  }

  /**
   * Set the selected value by key and update the queryParams.
   * @param key the key to set
   * @param value the value to set
   */
  selectValue(key: string, value: string) {
    const current = {...this._composedRoute.value};
    current[key] = value;
    this._composedRoute.next(current);
    this.updateQueryParams(current);
  }

  /**
   * Remove the key from the stored obj and update the queryParams
   * @param key The key to remove
   */
  removeValue(key: string): void {
    const current = {...this._composedRoute.value};
    delete current[key];
    this._composedRoute.next(current);
    setTimeout(() => {
      this.updateQueryParams(current);
    }, 10)
  }

  /**
   * expose changes for a specific key
   * @param key The key to search
   */
  onChangeRoute(key: string): Observable<string> {
    return this._composedRoute.asObservable().pipe(
      map(obj => obj[key]),
    );
  }
}

interface RouterCompose {
  [key: string]: string;
}

function encodeRoute(value: string) {
  return encodeURI(btoa(value));
}

function decodeRoute(value: string) {
  return decodeURI(atob(value));
}


